export const LOADING_LABORATORIOS = "LOADING_LABORATORIOS";
export const GET_LABORATORIOS_SUCCESS = "GET_LABORATORIOS_SUCCESS";
export const GET_LABORATORIOS_FAILURE = "GET_LABORATORIOS_FAILURE";
export const SET_LABORATORIOS_PAGE = "SET_LABORATORIOS_PAGE";
export const RESET_LABORATORIOS = "RESET_LABORATORIOS";
